import * as React from 'react';
import { IgcSelectGroupComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * @slot label - Contains the group's label.
 * @slot  - Intended to contain the items belonging to this group.
 * @csspart label - The native label element.
 * @class
 */
export const IgrSelectGroup = /* @__PURE__ */ createComponent({
  tagName: 'igc-select-group',
  displayName: 'IgrSelectGroup',
  elementClass: Component,
  react: React,
});

export type IgrSelectGroup = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrSelectGroupModule = Component;
